import { render } from "./ProjectSummaryPreorder.vue?vue&type=template&id=0d3a6dcd"
import script from "./ProjectSummaryPreorder.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryPreorder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__